'use strict';
import angular from 'angular';
import pinterestGeoLocationUrl from './views/pinterestGeoLocation.html';
var app = angular.module('app.pinterestGeoLocation.component', []);
app.component('pinterestGeoLocation', {
    bindings: {
        selectedPinterestGeoLocations : '=',
        clusterId : '=',
        showActions : '='
    },
    templateUrl: pinterestGeoLocationUrl,
    // The controller that handles our component logic
    controller: function($scope,$ioAlert, anchorSmoothScroll, $location, $timeout,$stateParams,FormService,ClusterService) {
        var self = this;
        self.disableRegions = false;
        var allowedCountries = [
            "AR", "AT", "AU", "BE", "BR", "CA", "CH", "CO", "CY", "CZ", "DE",
            "DK", "ES", "FI", "FR", "GB", "GR", "HK", "HU", "IE", "IL", "IT",
            "JP", "KR", "LU", "MT", "MX", "NL", "NO", "NZ", "PL", "PT", "RO",
            "SE", "SG", "SK", "US"
        ];
        self.orderId = $stateParams.orderId;
        self.rootLocation = { "id": 0, "children": "1", "criteria": "" };
        self.navSnapLocations = [];
        self.previousLocationData = [];
        self.geolocSearch = "";
        self.breadcrumbs = [];
        self.collectedNodes = [0];
        self.includeOrExcludeLocation = null;
        var geoLocationsCount = 0;
        self.selectedListOfLocations = [];
        self.showTabPanel = true;
        self.selectedInput = {
            value: 'snap_locations'
        }
        self.geoTextInputs = {
            inputValues: ''
        }
        self.textInputOptions = ["US Postal Codes", "US States", "US Cities"];
        self.textInputObj = {
            textInputType: "US Postal Codes"
        }
        self.selectedCriteria = {
            criteria: ""
        };
        self.criteria = ["include all", "exclude all"];
        self.showError = false;
        self.toggleComponent = function(selectedOption) {
            self.selectedInput.value = selectedOption;
        }
        $scope.$watch('$ctrl.geoTextInputs.inputValues', function() {
            if(self.geoTextInputs.inputValues.length == 0) {
                self.showError = false;
            }
        });
        $scope.$watch(function () {
                return {
                    locationPickers: self.selectedPinterestGeoLocations.selPinterestLocationPickers,
                    textInputs: self.selectedPinterestGeoLocations.selPinterestTextInputs
                };
            }, function (newVal) {
                var hasSelectedRegions = newVal.locationPickers && newVal.locationPickers.some(function (item) {
                    return item.type === "region";
                });

                var hasSelectedPostalCodes = newVal.textInputs && newVal.textInputs.some(function (item) {
                    return item.criteria_link === "included" && item.type === "postal_code";
                });

                self.disablePostalCodes = hasSelectedRegions;
                self.disableRegions = hasSelectedPostalCodes;
                self.handleTextInputChange();
            }, true
        );


        self.handleTextInputChange = function () {
            if (self.disablePostalCodes) {
                self.textInputOptions = self.textInputOptions.filter(opt => opt !== 'US Postal Codes');
            } else {
                if (!self.textInputOptions.includes('US Postal Codes')) {
                    self.textInputOptions.push('US Postal Codes');
                }
            }
        };
        $scope.$watchCollection('$ctrl.selectedPinterestGeoLocations.selPinterestLocationPickers', function (newCol, oldCol, scope) {
            _.map(newCol, function (item) {
                item.selectedInput = "snap_textInput";
                self.selectedListOfLocations.push(item)
            })
            self.selectedListOfLocations  = _.uniq(self.selectedListOfLocations);
        })
        $scope.$watchCollection('$ctrl.selectedPinterestGeoLocations.selPinterestTextInputs', function (newCol, oldCol, scope) {
            _.map(newCol, function (item) { self.selectedListOfLocations.push(item) })
            self.selectedListOfLocations = _.uniq(self.selectedListOfLocations);
        })
        self.handleChangeTextInput = function() {
            self.geoTextInputs.inputValues = '';
            self.showError = false;
        }
        /*
        * Handle validate postal codes
        */
        self.validateInputValues = function () {
            if (self.textInputObj.textInputType == "US Postal Codes") {
                var geoValues = self.geoTextInputs.inputValues.replace(/\n/g, ",").split(",");
                var type = "postal_code"
                var filteredValues = geoValues.filter(function (el) {
                    return el != "";
                });
                FormService.validateSnapPostalCodes(filteredValues, self.clusterId,type).then(function (data) {
                    if (data) {
                        processTextInputs(data);
                    }
                }, function (error) {
                    $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again ', 'error');
                });
            } else if (self.textInputObj.textInputType == "US States") {
                var geoValues = self.geoTextInputs.inputValues.replace(/\n/g, ",").split(",");
                var type = "region";
                var filteredValues = geoValues.filter(function (el) {
                    return el != "";
                });
                FormService.validateSnapGeo(filteredValues, self.clusterId, type).then(function (data) {
                    if (data) {
                        processTextInputs(data);
                    }
                }, function (error) {
                    $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again ', 'error');
                });
            } else if (self.textInputObj.textInputType == "US Cities") {
                var geoValues = self.geoTextInputs.inputValues.replace(/\n/g, ",").split(",");
                var type = "metro"
                var filteredValues = geoValues.filter(function (el) {
                    return el != "";
                });
                FormService.validateSnapGeo(filteredValues, self.clusterId,type).then(function (data) {
                    if (data) {
                        processTextInputs(data);
                    }
                }, function (error) {
                    $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again ', 'error');
                });
            }
        }
        /*
        * Handle process GET response
        */
        var processTextInputs = function(response) {
            if(response.valid && response.valid.length > 0) {
                _.each(response.valid, function(validGeoValue) {
                    validGeoValue.geoType = self.textInputObj.textInputType;
                    validGeoValue.criteria_link = 'included';
                    self.selectedPinterestGeoLocations.selPinterestTextInputs.push(validGeoValue);
                })
                self.geoTextInputs.inputValues = '';
            }
            if(response.invalid && response.invalid.length > 0){
                self.showError = true;
                self.geoTextInputs.inputValues = response.invalid.toString();
            }
        }
        self.getPostalCodesTooltips=function(selPinterestTextInputs){
            var data = angular.copy(selPinterestTextInputs);
            data = data.slice(5);
            var html=angular.element("<ul/>");
            angular.forEach(data,function(item){
                html.append("<li style='list-style:none;'>"+item.name+"</li>");
            });
            return html.html();
        };
        self.getLocationTooltips=function(locations){
            var data = angular.copy(locations);
            data = data.slice(2);
            var html=angular.element("<ul/>");
            angular.forEach(data,function(item){
                html.append("<li style='list-style:none;'>"+item.full_name+"</li>");
            });
            return html.html();
        };
        /*
        * Handle remove selected text inputs
        */
        self.removeTextInputs = function(removeItem) {
            var selIndex = _.findIndex(self.selectedPinterestGeoLocations.selPinterestTextInputs, {external_id: removeItem.external_id});
            if (selIndex >= 0) {
                self.selectedPinterestGeoLocations.selPinterestTextInputs.splice(selIndex, 1);
            }
        }
        /*
        * Handle Clear All Text Inputs
        */
        self.handleClearAllInputs = function() {
            self.selectedPinterestGeoLocations.selPinterestTextInputs = [];
        }
        self.handleClearSelectedLocations = function() {
            self.selectedPinterestGeoLocations.selPinterestLocationPickers = [];
            self.selectedPinterestGeoLocations.selPinterestTextInputs = [];
            self.selectedListOfLocations = [];
            self.selectedCriteria.criteria = 'none';
            geoLocationsCount = 0;
            self.includeOrExcludeLocation = null;
            _.each(self.navSnapLocations, function(navLocation) {
                navLocation.criteria = '';
                navLocation.criteria_link = 'include';
            });
        }
        self.handleChangeCriteria = function() {
            self.selectedPinterestGeoLocations.selPinterestLocationPickers = [];
            if(self.selectedCriteria.criteria == 'include all') {
                _.each(self.navSnapLocations, function(navLocation) {
                    navLocation.criteria = 'include';
                    navLocation.criteria_link = 'included';
                    navLocation.full_name = self.buildFullName(navLocation);
                    self.selectedPinterestGeoLocations.selPinterestLocationPickers.push(navLocation);
                });
            } else if(self.selectedCriteria.criteria == 'exclude all') {
                _.each(self.navSnapLocations, function(navLocation) {
                    navLocation.criteria = 'exclude';
                    navLocation.criteria_link = 'excluded';
                    navLocation.full_name = self.buildFullName(navLocation);
                    self.selectedPinterestGeoLocations.selPinterestLocationPickers.push(navLocation);
                });
            } else {
                _.each(self.navSnapLocations, function(navLocation) {
                    navLocation.criteria = '';
                    navLocation.criteria_link = 'include';
                });
            }
        }
        self.getChildrenNodes = function(item) {
            if (item.children > 0) {
                if (self.collectedNodes.indexOf(item.id) < 0) {
                    FormService.getSnapGeoLocationsById(self.orderId,self.clusterId,item.country_code).then(function(success) {
                        self.collectedNodes.push(item.id);
                        self.locations = self.locations.concat(success);
                        self.getLocationChilds(item);
                        self.geolocSearch = "";
                    }, function(error) {
                        $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again ', 'error');
                    });
                } else {
                    self.getLocationChilds(item);
                }
            }
        };
        self.showtabPanel = function() {
            self.showTabPanel = !self.showTabPanel;
        }
        self.getLocationChilds = function(item) {
            if (item.children > 0) {
                self.navSnapLocations = [];
                if (self.locations) {
                    for (var i = 0, len = self.locations.length; i < len; i++) {
                        if (self.locations[i].parent_id == item.id) {
                            if (self.selectedPinterestGeoLocations.selPinterestLocationPickers.length > 0) {
                                var selIndex = _.findIndex(self.selectedPinterestGeoLocations.selPinterestLocationPickers, { id: self.locations[i].id });
                                if (selIndex !== -1) {
                                    self.locations[i].criteria = self.selectedPinterestGeoLocations.selPinterestLocationPickers[selIndex].criteria;
                                    self.includeOrExcludeLocation = self.selectedPinterestGeoLocations.selPinterestLocationPickers[selIndex].criteria + 'location';
                                }
                            } else{
                                self.locations[i].criteria = "";
                            }
                            if (self.locations[i].criteria.length == 0 && item.criteria.length > 0) {
                                self.locations[i].criteria = item.criteria;
                            }
                            self.locations[i].criteria_link = 'include';
                            if (self.locations[i].criteria == "include") {
                                self.locations[i].criteria_link = 'included';
                            } else if (self.locations[i].criteria == "exclude") {
                                self.locations[i].criteria_link = 'excluded';
                            }
                            self.navSnapLocations.push(self.locations[i]);
                            self.checkingCriteria();
                        }
                    }
                    self.previousLocationData = angular.copy(self.navSnapLocations);
                }
                self.breadcrumbs = [];
                self.buildBreadcrumbs(item);
            }
        }
        self.changeIncludeExclude = function(item, criteria) {
            var index = self.navSnapLocations.indexOf(item);
            if (index >= 0) {
                if (criteria == "include") {
                    self.navSnapLocations[index].criteria = 'include';
                    self.navSnapLocations[index].criteria_link = 'included';
                } else if (criteria == "exclude") {
                    self.navSnapLocations[index].criteria = 'exclude';
                    self.navSnapLocations[index].criteria_link = 'excluded';
                } else {
                    self.navSnapLocations[index].criteria = '';
                    self.navSnapLocations[index].criteria_link = 'include';
                }
                if(geoLocationsCount < 1) {
                    self.includeOrExcludeLocation = criteria + 'location';
                }
                var selIndex = _.findIndex(self.selectedPinterestGeoLocations.selPinterestLocationPickers, { id: self.navSnapLocations[index].id });
                self.navSnapLocations[index].full_name = self.buildFullName(self.navSnapLocations[index])
                if (selIndex >= 0) {
                    self.selectedPinterestGeoLocations.selPinterestLocationPickers[selIndex] = self.navSnapLocations[index];
                } else {
                    self.selectedPinterestGeoLocations.selPinterestLocationPickers.push(self.navSnapLocations[index]);
                }
                changeAllChildCriteria(self.navSnapLocations[index].id, self.navSnapLocations[index].criteria);
                for(var i=0; i<self.selectedPinterestGeoLocations.selPinterestLocationPickers.length; i++){
                    var parentId = parseInt(self.selectedPinterestGeoLocations.selPinterestLocationPickers[i].parent_id);
                    var parentObj = _.find(self.locations, {id: parentId});
                    if(parentObj && parentObj.criteria === self.selectedPinterestGeoLocations.selPinterestLocationPickers[i].criteria ){
                        self.selectedPinterestGeoLocations.selPinterestLocationPickers.splice(i, 1);
                    }
                }
                geoLocationsCount++;
            }
        }
        self.removeLoc = function (item) {
            if (item.selectedInput == "snap_textInput") {
                var selIndex = self.selectedPinterestGeoLocations.selPinterestLocationPickers.indexOf(item);
                self.selectedListOfLocations.splice(self.selectedListOfLocations.indexOf(item),1)
                if (selIndex >= 0) {
                    self.selectedPinterestGeoLocations.selPinterestLocationPickers.splice(selIndex, 1);
                    if (self.selectedPinterestGeoLocations.selPinterestLocationPickers.length == 0) {
                        geoLocationsCount = 0;
                        self.includeOrExcludeLocation = null;
                    }
                }
                var parentId = parseInt(item.parent_id);
                var parentLocation = _.find(self.locations, { id: parentId });
                var locationObj = _.find(self.locations, { id: item.id });
                if (locationObj) {
                    if (parentLocation) {
                        if (parentLocation.criteria == "include") {
                            locationObj.criteria = 'include';
                            locationObj.criteria_link = 'included';
                        } else if (parentLocation.criteria == "exclude") {
                            locationObj.criteria = 'exclude';
                            locationObj.criteria_link = 'excluded';
                        } else {
                            locationObj.criteria = '';
                            locationObj.criteria_link = 'include';
                        }
                    } else {
                        locationObj.criteria = '';
                        locationObj.criteria_link = 'include';
                        for (var k = 0; k < self.navSnapLocations.length; k++) {
                            if (self.navSnapLocations[k].name == item.name) {
                                self.navSnapLocations[k].criteria = '';
                                self.navSnapLocations[k].criteria_link = 'include';
                                break;
                            }
                        }
                        self.previousLocationData = angular.copy(self.navSnapLocations);
                    }
                    changeAllChildCriteria(item.id, locationObj.criteria);
                } else {
                    for (var k = 0; k < self.navSnapLocations.length; k++) {
                        if (self.navSnapLocations[k].name == item.name) {
                            self.navSnapLocations[k].criteria = '';
                            self.navSnapLocations[k].criteria_link = 'include';
                            break;
                        }
                    }
                }
                for (var i = 0; i < self.selectedPinterestGeoLocations.selPinterestLocationPickers.length; i++) {
                    if (self.selectedPinterestGeoLocations.selPinterestLocationPickers[i].parent_id == String(item.id)) {
                        self.selectedPinterestGeoLocations.selPinterestLocationPickers.splice(i, 1);
                    }
                }
            } else {
                var selIndex = _.findIndex(self.selectedPinterestGeoLocations.selPinterestTextInputs, {id: item.id});
                if (selIndex >= 0) {
                    self.selectedPinterestGeoLocations.selPinterestTextInputs.splice(selIndex, 1);
                    self.selectedListOfLocations.splice(self.selectedListOfLocations.indexOf(item),1)
                }
            }
        }
        function changeAllChildCriteria(parentId, criteria = ""){
            _.each(self.locations, function(location){
                if(location.parent_id==parentId){
                    if(criteria == "include"){
                        location.criteria = 'include';
                        location.criteria_link = 'included';
                    }else if(criteria == "exclude"){
                        location.criteria = 'exclude';
                        location.criteria_link = 'excluded';
                    }else{
                        location.criteria = '';
                        location.criteria_link = 'include';
                    }
                    changeAllChildCriteria(location.id, location.criteria);
                }
            });
        }

        self.searchSnapLocation = function (geolocSearch) {
            if (event.keyCode != 13) {
                var cacheKey = 'cachedSearchData';
                var cacheExpirationKey = 'cacheExpiration';
                var cacheExpirationTime = 7 * 24 * 60 * 60 * 1000; // 7 days
                var currentTime = new Date().getTime();

                // Retrieve cached data and expiration timestamp from local storage
                var cachedData = JSON.parse(localStorage.getItem(cacheKey)) || [];
                var cacheExpiration = parseInt(localStorage.getItem(cacheExpirationKey)) || 0;

                // Check if cached data is expired
                if (currentTime > cacheExpiration) {
                    cachedData = []; // Clear outdated cache
                    localStorage.removeItem(cacheKey);
                    localStorage.removeItem(cacheExpirationKey);
                }

                // Function to filter data based on the search term
                function filterData(data, searchTerm) {
                    return data.filter(item =>
                        item.name.toLowerCase().includes(searchTerm.toLowerCase()) &&
                        (item.type !== 'country' || allowedCountries.includes(item.country_code?.toUpperCase()))
                    );
                }

                if (geolocSearch.length > 0) {
                    var filteredCachedData = filterData(cachedData, geolocSearch);

                    if (filteredCachedData.length > 0) {
                        // Use cached data if available
                        self.searchData = filteredCachedData;
                        processData(self.searchData);
                    } else {
                        // Make backend call if no cached data matches
                        FormService.getSnapGeoSearchlocations(geolocSearch, self.clusterId).then(function (success) {
                            if (success && success.length > 0) {
                                // Filter locations to ensure country codes are in allowedCountries for type 'country'
                                self.searchData = success.filter(function (location) {
                                    return location.name.toLowerCase().includes(geolocSearch.toLowerCase()) &&
                                        (location.type !== 'country' || allowedCountries.includes(location.country_code?.toUpperCase()));
                                });

                                // Cache the new data
                                localStorage.setItem(cacheKey, JSON.stringify(self.searchData));
                                var newCacheExpiration = currentTime + cacheExpirationTime; // Calculate new expiration time
                                localStorage.setItem(cacheExpirationKey, newCacheExpiration.toString());

                                // Process the filtered data
                                processData(self.searchData);
                            } else {
                                // No matches found
                                self.searchData = [];
                                processData(self.searchData);
                            }
                        }, function (error) {
                            // Handle error
                            console.error("Error fetching search locations:", error);
                        });
                    }
                } else {
                    // Handle empty search query
                    self.searchData = [];
                    self.navSnapLocations = [];
                    self.navSnapLocations = angular.copy(self.previousLocationData);
                    self.checkingCriteria();
                }
            }

            // Process the filtered data
            function processData(data) {
                self.navSnapLocations = [];
                _.each(data, function (item, i) {
                    var index = self.locations.findIndex(x => x.id == item.id);
                    if (index > -1) {
                        self.navSnapLocations.push(self.locations[index]);
                    } else {
                        self.navSnapLocations[i] = item;
                        self.navSnapLocations[i].criteria = item.criteria;
                        self.navSnapLocations[i].criteria_link = 'include';
                        self.navSnapLocations[i].name = item.name;
                        self.navSnapLocations[i].parent_name = item.parent_name;
                    }
                });
                self.checkingCriteria();
            }
        };

        self.checkingCriteria = function(){
            for(var k=0;k<self.selectedPinterestGeoLocations.selPinterestLocationPickers.length;k++){
                for(var j=0;j<self.navSnapLocations.length;j++){
                    if(self.selectedPinterestGeoLocations.selPinterestLocationPickers[k].name == self.navSnapLocations[j].name){
                        if (self.selectedPinterestGeoLocations.selPinterestLocationPickers[k].criteria == "include") {
                            self.navSnapLocations[j].criteria = 'include';
                            self.navSnapLocations[j].criteria_link = 'included';
                        } else if (self.selectedPinterestGeoLocations.selPinterestLocationPickers[k].criteria == "exclude") {
                            self.navSnapLocations[j].criteria = 'exclude';
                            self.navSnapLocations[j].criteria_link = 'excluded';
                        }else{
                            self.navSnapLocations[j].criteria = '';
                            self.navSnapLocations[j].criteria_link = 'include';
                        }
                    }
                }
            }
        }
        self.buildBreadcrumbs = function(item) {
            if (item.parent_id || item.parent_id == 0) {
                self.breadcrumbs.unshift(item);
                if (item.parent_id == 0) {
                    return false;
                } else {
                    var obj = _.find(self.locations, function(loc) {
                        return loc.id == item.parent_id
                    });
                    self.buildBreadcrumbs(obj);
                }
            }
        }
        self.buildFullName = function(item) {
            if (item.parent_id == 0) {
                return item.name + ".";
            } else {
                var obj = _.find(self.locations, function(loc) {
                    return loc.id == item.parent_id
                });
                if(obj == undefined && item.parent_name){
                    return item.name + " , " + item.parent_name +"."
                } else {
                    return item.name + ", " + self.buildFullName(obj);
                }
            }
        }
        var getLocations = function() {
            FormService.getSnapGeoLocationsById(self.orderId,self.clusterId,"NA").then(function(success) {
                self.locations = success.filter(function(location) {
                    return allowedCountries.includes(location.country_code.toUpperCase());
                });

                self.getLocationChilds(self.rootLocation);
            }, function(error) {
                $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
            });
        };
        var initLocations = function() {
            if (typeof self.selectedPinterestGeoLocations === 'string' && !_.isEmpty(self.selectedPinterestGeoLocations)) {
                self.selectedPinterestGeoLocations = JSON.parse(self.selectedPinterestGeoLocations);                if(self.showActions) {
                    self.editMode = true;
                    self.enableViewMode = false;
                    getLocations();
                    if(self.selectedPinterestGeoLocations.selPinterestTextInputs && self.selectedPinterestGeoLocations.selPinterestTextInputs.length > 0){
                        self.textInputObj.textInputType = self.selectedPinterestGeoLocations.selPinterestTextInputs[0].geoType ? self.selectedPinterestGeoLocations.selPinterestTextInputs[0].geoType : "US Postal Codes";
                    }
                } else {
                    self.editMode = false;
                    self.enableViewMode = true;
                }
            } else {
                self.selectedPinterestGeoLocations = {
                    selPinterestLocationPickers: [],
                    selPinterestTextInputs: []
                };
                self.enableViewMode = false;
                self.editMode = false;
                getLocations();
            }
        };
        initLocations();
    }
});
